/**
 * @author Harshitha.k
 * @description 
 */

import './map.css';
import L from 'leaflet';
import moment from 'moment';
import 'leaflet/dist/leaflet.css';
import { connect } from 'react-redux';
import Location from './Location.png';
import React, { useEffect, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import ReactEcharts from '../Utils/Echarts/Echarts';
import StyledTable from '../../../../../commons/styles/table';
import { Button, DatePicker, Input, message, Select } from 'antd';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import {
  getCounterData,
  getMapsData,
  getTableData,
  getTrainList,
  getVerticalLineData
} from './APIcalls';

const CMRL_page = ({ translationCache, defaultHiearchy }) => {
  const [option, setOption] = useState({
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    legend: {
      textStyle: {
        color: 'white',
        fontSize: 16,
        fontWeight: 'bold'
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: 'white'
        }
      },
      axisTick: {
        lineStyle: {
          color: 'white'
        },
        interval: 1
      },
      axisLabel: {
        color: 'white'
      }
    },
    yAxis: {
      type: 'category',
      data: [],
      axisLine: {
        lineStyle: {
          color: 'white'
        }
      },
      axisTick: {
        lineStyle: {
          color: 'white'
        },
        interval: 1
      },
      axisLabel: {
        color: 'white'
      }
    },
    series: []
  });

  const [selectedDate, setSelectedDate] = useState(moment().format('YYYY-MM-DD'));
  const [TableData, setTableData] = useState([]);
  const [CounterData, setCounterData] = useState([]);
  const [MapsData, setMapsData] = useState([]);
  const [TrainList, setTrainList] = useState([]);
  const [DeviceCode, setDeviceCode] = useState('');
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    getData(selectedDate);
  }, [selectedDate]);

  const getData = async (date) => {
    let hierarchyCode = defaultHiearchy?.HierarchyCode || 'ChennaiMetro_DefalutConfiguration';
    const CounterDataPromises = [
      getCounterData(5, 'Total Faults', date),
      getCounterData(3, 'Priority 1 Faults', date),
      getCounterData(4, 'Priority 2 Faults', date),
      getCounterData(7, 'Active Faults', date),
      getCounterData(6, 'Closed Faults', date)
    ];

    const CounterDataResults = await Promise.all(CounterDataPromises);
    const CounterData = CounterDataResults.map(data => data[0] || {});

    const TrainList = await getTrainList(hierarchyCode);
    if (TrainList && TrainList[0]?.Code) {
      setDeviceCode(TrainList[0].Code);
      const TableData = await getTableData(date, TrainList[0].Code);
      setTableData(TableData);
    } else {
      message.error('Error fetching trains');
    }

    const LineData = await getVerticalLineData(date);
    const MapsData = await getMapsData(date);
    UpdateLineOptions(LineData);
    setCounterData(CounterData);
    setMapsData(MapsData);
    setTrainList(TrainList);
  };

  const removeDuplicateObjectsByKey = (array, fieldToDuplicateCheck) => {
    const newArray = [];
    const arrayKeys = [];
    array.forEach((item) => {
      if (!arrayKeys.includes(item[fieldToDuplicateCheck])) {
        arrayKeys.push(item[fieldToDuplicateCheck]);
        newArray.push(item);
      }
    });
    return newArray;
  };

  const UpdateLineOptions = (LineData) => {
    let trainList = removeDuplicateObjectsByKey(LineData, 'DateTime');
    let descriptionList = removeDuplicateObjectsByKey(LineData, 'Description');
    const newOption = {
 ...option,
      yAxis: {
        type: 'category',
        data: trainList.map(train => train.DateTime),
        axisLine: {
          lineStyle: {
            color: 'white'
          }
        },
        axisTick: {
          lineStyle: {
            color: 'white'
          },
          interval: 1
        },
        axisLabel: {
          color: 'white'
        }
      },
      series: descriptionList.map(desc => ({
        name: desc.Description,
        type: 'bar',
        stack: 'total',
        label: {
          show: true
        },
        emphasis: {
          focus: 'series'
        },
        data: LineData.filter(e => e.Description === desc.Description).map(barData => barData.Value)
      }))
    };
    setOption(newOption);
  };

  const onDateChange = (date, dateString) => {
    setSelectedDate(dateString);
  };

  const handleDeviceChange = async (code) => {
    setDeviceCode(code);
    const TableData = await getTableData(selectedDate, code);
    const CounterDataPromises = [
      getCounterData(5, 'Total Faults', selectedDate),
      getCounterData(3, 'Priority 1 Faults', selectedDate),
      getCounterData(4, 'Priority 2 Faults', selectedDate),
      getCounterData(7, 'Active Faults', selectedDate),
      getCounterData(6, 'Closed Faults', selectedDate)
    ];
    const CounterDataResults = await Promise.all(CounterDataPromises);
    const CounterData = CounterDataResults.map(data => data[0] || {});
    setCounterData(CounterData);
    setTableData(TableData);
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => { this.searchInput = node; }}
          placeholder={translation('Search')}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const columns = TableData.length > 0 ? Object.keys(TableData[0]).map(colKey => ({
    title: colKey,
    dataIndex: colKey,
    key: colKey,
    ...getColumnSearchProps(colKey)
  })) : [];

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <DatePicker
          style={{ marginRight: '10px' }}
          value={moment(selectedDate, 'YYYY-MM-DD')}
          onChange={onDateChange}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ width: '25%', height: '100vh' }}>
          <ReactEcharts
            option={option}
            className="react_for_echarts"
            style={{ height: '80%', width: '100%' }}
          />
        </div>
        <div style={{ width: '75%', height: '100vh' }}>
          <div className="flex-container">
            {CounterData && Array.isArray(CounterData) && CounterData.map((counter, index) => (
              <div
                key={index}
                className="flex-item"
                style={{
                  border: '1px solid white',
                  color: 'white',
                  
                  fontWeight: '800',
                  borderRadius: '18px'
                }}
              >
                <div
                  style={{
                    padding: '10px',
                    display: 'flex',
                    justifyContent: 'center',
                    borderBottom: '1px solid'
                  }}
                >
                  {counter.Name || ''}
                </div>
                <div style={{ padding: '14px' }}>
                  {counter.Value || ''}
                </div>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Select
              placeholder={'Select Device'}
              onChange={handleDeviceChange}
              value={DeviceCode}
              style={{ width: 200, marginRight: '10px' }}
            >
              {TrainList && Array.isArray(TrainList) && TrainList.map((train, index) => (
                <Select.Option key={index} value={train.Code}>
                  {train.Name}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div style={{ padding: '10px' }}>
            <MapContainer
              center={
                MapsData[0]?.ParentLatitude && MapsData[0]?.ParentLongitude
                  ? [MapsData[0].ParentLatitude, MapsData[0].ParentLongitude]
                  : [51.0, 19.0]
              }
              zoom={4}
              style={{ height: '400px', width: '100%' }}
            >
              <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
              />
              {MapsData && Array.isArray(MapsData) && MapsData.map((mark, index) => (
                <Marker
                  key={index}
                  icon={
                    new L.Icon({
                      iconUrl: `${Location}`,
                      iconRetinaUrl: `${Location}`,
                      popupAnchor: [-0, -0],
                      iconSize: [15, 15]
                    })
                  }
                  position={[mark.Latitude || 0, mark.Longitude || 0]}
                >
                  <Popup>
                    <div style={{ fontWeight: 'bold' }}>
                      Station: {mark.Station || ''}
                      <br />
                      Total Faults: {mark['Total Faults'] || ''}
                      <br />
                      Priority-1 Faults: {mark['Priority-1 Faults'] || ''}
                      <br />
                      Priority-2 Faults: {mark['Priority-2 Faults'] || ''}
                      <br />
                    </div>
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          </div>
          <div style={{ padding: '10px' }}>
            <StyledTable size="small"
              dataSource={TableData}
              columns={columns}
              pagination={{ pageSize: 5 }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  defaultHiearchy: state.LayoutReducer.DefaultHierarchy
});

export default connect(mapStateToProps)(CMRL_page);